export default __webpack_public_path__ + "static/pic13-0ac3e1fb21328df1f277c817339937d3.jpg";